import { Tooltip } from 'antd'
import { Actions } from 'components/atoms'
import { ActionType } from 'components/atoms/actions'
import { ActionsDelete } from 'constants/actionsType'
import { useFormatData } from 'hooks'
import { t } from 'i18next'
import { ISubService } from 'pages/menuSubServices/interfaces'
import { StyledStatus } from 'styles/styledGlobal'

export const useColumnService = (
  onAction: (type: ActionType, row: ISubService) => void
) => {
  const { getNumberCommasFixed } = useFormatData()
  return [
    {
      key: '#',
      title: '#',
      align: 'center',
      dataIndex: '#',
      width: 20,
      render: (_: any, __: any, index: number) => index + 1
    },
    {
      key: 'name',
      title: t('service'),
      width: 60,
      dataIndex: 'name',
      render: (name: any) => (
        <Tooltip title={name} color="white">
          {name}
        </Tooltip>
      )
    },
    {
      key: 'status',
      title: t('status'),
      width: 50,
      dataIndex: 'status',
      render: (status: any) => (
        <StyledStatus $status={status} style={{ fontWeight: 600 }}>
          {t(status)}
        </StyledStatus>
      )
    },
    {
      key: 'quantity',
      title: t('quantity'),
      width: 40,
      dataIndex: 'quantity',
      render: (quantity: any) => <></>
    },
    {
      key: 'price',
      title: t('unit-price'),
      width: 40,
      dataIndex: 'price',
      alig2: 'right',
      render: (price: any) => `${getNumberCommasFixed(Number(price) * 1000)}`
    },
    {
      key: 'into-money',
      title: t('into-money'),
      width: 40,
      dataIndex: 'into-money',
      align: 'right',
      render: (price: any) => <></>
    },
    {
      key: 'action',
      title: t('action'),
      width: 35,
      dataIndex: 'action',
      align: 'center',
      render: (value: any, row: any) => (
        <Actions
          actions={ActionsDelete}
          onClick={(actionType) => onAction(actionType, row)}
        />
      )
    }
  ]
}
